module.exports = __webpack_public_path__ + "static/media/blue-location.d258e0db.svg";